module.exports = __webpack_public_path__ + "img/s3-300x81.533cb484.jpg";